import { defineComponent as _defineComponent } from 'vue'
import {
  TUIGlobal,
  TUITranslateService,
} from "@tencentcloud/chat-uikit-engine";
import {
  defineProps,
  watchEffect,
  ref,
  defineEmits,
} from "../../../adapter-vue";
import Icon from "../../common/Icon.vue";
import editIcon from "../../../assets/icon/edit.png";
import { Toast, TOAST_TYPE } from "../../common/Toast/index";


export default /*#__PURE__*/_defineComponent({
  __name: 'manage-name',
  props: {
  data: {
    type: Object,
    default: () => ({}),
  },
  isAuthor: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update"],
  setup(__props, { emit }) {

const props = __props



const groupProfile = ref({});
const inputGroupName = ref("");
const isEdit = ref(false);
const dialog = ref(null);
const isPC = ref(TUIGlobal.getPlatform() === "pc");

watchEffect(() => {
  groupProfile.value = props.data;
});



const updateProfile = () => {
  if(!inputGroupName.value) {
    Toast({
      message: "群名称不能为空",
      type: TOAST_TYPE.ERROR
    });
  } else {
    if(inputGroupName.value !== groupProfile.value.name) {
      emit("update", { key: "name", value: inputGroupName.value });
      groupProfile.value.name = inputGroupName.value;
      inputGroupName.value = "";
      Toast({
        message: "群名称修改成功",
        type: TOAST_TYPE.ERROR
      });
    }
    toggleEdit();
  }
};

const toggleEdit = async () => {
  if (props.isAuthor) {
    isEdit.value = !isEdit.value;
  }
  if (isEdit.value) {
    inputGroupName.value = groupProfile.value.name;
  }
};

return { __sfc: true,props, groupProfile, inputGroupName, isEdit, dialog, isPC, emit, updateProfile, toggleEdit, TUITranslateService, Icon, editIcon }
}

})